import { Chip, Stack } from "@mui/material";
import { Icon } from "@iconify/react";

function VerificationBadge({ user }) {
  const chips = [];
  if (user?.isVerifiedUser) {
    chips.push({
      label: "Verified user",
      textColor: "#5751E9",
      bgColor: "#E7E6FF66",
      iconBg: "#5751E9",
      border: "0.4px solid #D3484812",
    });
  }

  if (user?.isAbhaVerified) {
    chips.push({
      label: "ABHA Verified",
      textColor: "#2E7D32",
      bgColor: "#DDE8DF",
      iconBg: "#2E7D32",
      border: "0.4px solid #D3484812",
    });
  }

  return (
    <Stack direction="row" spacing={1}>
      {chips.map((config, index) => (
        <Chip
          key={index}
          label={config.label}
          icon={
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: config.iconBg,
              }}
            >
              <Icon icon="mdi:check" width="14" color="#fff" />
            </span>
          }
          sx={{
            backgroundColor: config.bgColor,
            color: config.textColor,
            fontWeight: 600,
            fontSize: 12,
            px: 1,
            borderRadius: "4px",
            border: config.border,
            p: "6px",
            height: "26px",
            "& .MuiChip-icon": {
              marginLeft: "6px",
            },
          }}
        />
      ))}
    </Stack>
  );
}

export default VerificationBadge;